import { get as getMsaAliasToId } from 'dynamic-data/msa-alias-to-id';

export const MSA_ALIAS_TO_ID = getMsaAliasToId();

export const msaAliasToId = alias => MSA_ALIAS_TO_ID[alias] || null;
export const msaIdToAlias = id => Object.keys(MSA_ALIAS_TO_ID).find(key => MSA_ALIAS_TO_ID[key] === parseInt(id, 10));
